import { DeviceRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * deviceOnSaveData - Function that saves on database an new device   
 * /devices  
 * method POST 
 * @async-function
 */
const deviceOnSaveData = async (token: string, model: DeviceRequestType) => {
    const response = await api.post(
        `/devices`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default deviceOnSaveData;